module.exports = new __parcel__URL__("lune-nuage-1.647e6658.svg").toString();